import React, { Component, Fragment } from 'react'
import {
    Button,
    Modal, ModalBody, ModalFooter,
    ModalHeader
} from 'reactstrap'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import * as checkpoints from 'catalog/actions/checkpoints'
import Select from 'react-select';

@connect(
    state => ({
        categoryList: state.categories.categoryList,
        activeSubcategory: state.categories.activeSubcategory
    }),
    dispatch => ({
        update: (category) => dispatch(checkpoints.updateCheckpoint(category)),
        fetch: () => dispatch(checkpoints.fetchCheckpointList()),
    })
)
export default class MoveCheckpoint extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            target: null
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({ isOpen })
    }

    @autobind
    confirm() {
        const { update, checkpoint } = this.props;
        const { target } = this.state;
        if (target) {
            update({
                ...checkpoint,
                category: target
            });
            this.toggle();
        }
    }

    render() {
        const {
            isOpen
        } = this.state
        const {
            categoryList,
            activeSubcategory
        } = this.props
        return (
            <Fragment>
                <Button color='primary' title='Checkpoint verschieben'
                    onClick={this.toggle}>
                    <i className='fa fa-arrows-alt'> </i>
                </Button>
                <Modal isOpen={isOpen}>
                    <ModalHeader>
                        Checkpoint verschieben
                    </ModalHeader>
                    <ModalBody>
                        <Select options={
                            categoryList.map(
                                el => ({
                                    label: el.name,
                                    options: el.children.filter(el => el.id !== activeSubcategory.id).map(
                                        sel => ({
                                            label: sel.name,
                                            value: sel.id
                                        })
                                    )
                                })
                            )
                        } onChange={option => this.setState({ target: option.value })} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color='danger'
                            onClick={this.confirm}>Bestätigen</Button>
                        <Button color='default'
                            onClick={this.toggle}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}
